import { LocalizedData } from './localized-data';
import { ImageData } from './localized-domain-images';
import { PageItemCommon } from './page-item';
import { TrayWithBackgroundImages, TrayWithLocalizedTitle } from './tray-common';

export enum PartnerVoucherType {
  VoucherCode = 'VoucherCode',
  CardNumber = 'CardNumber',
}

export interface RedeemPartnerVoucherTray extends PageItemCommon, TrayWithLocalizedTitle, TrayWithBackgroundImages {
  type: 'RedeemPartnerVoucherTray';

  campaignCode: string;

  mainCtaText: LocalizedData<string>;
  voucherBoxText: LocalizedData<string>;
  instructionText: LocalizedData<string>;
  buttonText: LocalizedData<string>;

  voucherType: PartnerVoucherType;

  partnerLogo: ImageData;
}
